import type { NextPage } from 'next'
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';


interface IProps {
  children: React.ReactNode;
  theme?: "primary" | "success" | "danger" | "warning" | "info" | "default";
  size?: "default" | "normal" | "l" | "s" | "xs";
  rounded?: boolean;
  form?: string;
  type?: "button" | "submit" | "reset" | undefined;
  className?: string;
  gotoBack?: boolean;
  onClick?: (e?: any) => void;
}

const Component: NextPage<IProps> = ({ children, theme, size, rounded, form, type, className, gotoBack, onClick }) => {
  const Router = useRouter()
  const [buttonTheme, setButtonTheme] = useState('');
  const [injectedClasses, setInjectedClasses] = useState('');
  const [buttonSize, setButtonSize] = useState('');

  let buttonProps = {}
  onClick && (buttonProps = {...buttonProps, ...{onClick}})
  gotoBack && (buttonProps = {...buttonProps, ...{onClick: () => Router.back()}})
  form && (buttonProps = {...buttonProps, ...{form}})
  const buttonType = type ? type : 'button'
  buttonProps = {...buttonProps, ...{type: buttonType}}

  useEffect(() => {
    const t = theme || 'default'
    if (t === 'default') {
      setButtonTheme(`text-button-${t}-text outline outline-1 outline-button-${t}-text hover:text-button-${t}-hover-text hover:bg-button-${t}-hover-bg`)
    } else {
      setButtonTheme(`text-button-${t}-text outline outline-1 outline-button-${t}-bg bg-button-${t}-bg hover:text-button-${t}-hover-text hover:bg-button-${t}-hover-bg`)
    }
    setInjectedClasses(className ? className : '')

    if (size === 'l') {
      setButtonSize('py-4 px-8 text-body1')
    } else if (size === 's') {
      setButtonSize('py-1 px-2 text-caption')
    } else if (size === 'xs') {
      setButtonSize('py-1 px-1 text-overline')
    } else {
      setButtonSize('py-2 px-4 text-button')
    }
  }, [className, theme, size]);

  return (
    <button
      {...buttonProps}
      className={`${buttonTheme} ${buttonSize} ${rounded === true && 'rounded'} ${injectedClasses}`}
    >
      <div className="flex items-center justify-center">
        {children}
      </div>
    </button>
  )
}

export default Component
